/* unplugin-vue-components disabled */import { render } from "./Discount.vue?vue&type=template&id=e8c2b24a&scoped=true&ts=true"
import script from "./Discount.vue?vue&type=script&lang=ts"
export * from "./Discount.vue?vue&type=script&lang=ts"

import "./Discount.vue?vue&type=style&index=0&id=e8c2b24a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c2b24a"]])

export default __exports__